import { buttonGroupClasses } from "@mui/material/ButtonGroup";
export const ButtonGroup = {
    MuiButtonGroup: {
        defaultProps: {
            variant: "text",
            size: "small"
        },
        styleOverrides: {
            root: ({ theme })=>({
                    boxShadow: theme.shadows[5],
                    [`&.${buttonGroupClasses.disableElevation}`]: {
                        boxShadow: "none"
                    }
                })
        }
    }
};

//# sourceMappingURL=ButtonGroup.js.map